import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Modal from "@material-ui/core/Modal";
import { Cancel } from "@material-ui/icons";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory } from "react-router-dom";
import Switch from "@material-ui/core/Switch";
import Logo from "../../img/UBEC-logo.png";
import "./profilebox.css";
import FileService from "../../services/file.service";
import UserService from "../../services/user.service";
import Preloader from "../preloader/Preloader";
import Profile from "../../img/avi.png";
import { baseURL } from "../../common/constants.js";

function rand() {
	return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
	const top = 50 + rand();
	const left = 50 + rand();

	return {
		top: `${top}%`,
		left: `${left}%`,
		transform: `translate(-${top}%, -${left}%)`,
	};
}

const useStyles = makeStyles((theme) => ({
	paper: {
		position: "absolute",
		width: 400,
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
	},
	gridContainer: {
		width: "100%",
	},
	gridContent: {
		padding: "30px 60px",
	},
	profileContainer: {
		width: "80%",
		margin: "0px auto",
	},
	backBtn: {
		position: "absolute",
		top: "30px",
		left: "0px",
	},
	imgContainer: {
		display: "flex",
		justifyContent: "center",
		position: "relative",
	},
	imgLogo: {
		width: "100px",
		height: "100px",
		objectFit: "cover",
	},
	chatbox: {
		width: "100%",
		padding: "10px",
		borderRadius: "6px",
		marginTop: "20px",
		fontSize: "20px",
		textAlign: "center",
		color: "white",
		backgroundColor: "#901919",
	},
	usernameContainer: {
		display: "flex",
		justifyContent: "space-between",
	},
	username: {
		fontWeight: "bold",
		marginTop: "10px",
		textTransform: "Capitalize",
	},
	profileBox: {
		border: "1px solid rgba(144, 25, 25, 0.02)",
		boxShadow: "0px 4px 4px rgba(144, 25, 25, 0.05)",
		padding: "10px",
	},
	profileBoxText: {
		fontWeight: "600",
		margin: "20px",
	},

	chats: {
		width: "100%",
		height: "300px",
		border: "1px solid black",
	},
}));

const ProfileBox = () => {
	const history = useHistory();
	const classes = useStyles();
	const [currentUser, setCurrentUser] = useState(null);
	const [fetching, setFetching] = useState(false);
	const [submitting, setSubmitting] = useState(false);
	const [file, setFile] = useState(null);
	const [state, setState] = useState({
		checkedB: true,
	});

	const [modalStyle] = useState(getModalStyle);
	const [open, setOpen] = useState(false);

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleChange = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });
	};

	const body = (
		<div style={modalStyle} className={classes.paper}>
			<div className={classes.profileBox}>
				<p id="simple-modal-description">View Profile</p>
				<p id="simple-modal-description1">Delete Chat </p>
				<p id="simple-modal-description2">
					{" "}
					Mute Chat
					<Switch
						checked={state.checkedB}
						onChange={handleChange}
						color="primary"
						name="checkedB"
						inputProps={{ "aria-label": "primary checkbox" }}
					/>
				</p>
				<p id="simple-modal-description3"> Mark Unread </p>
				<p id="simple-modal-description4">Mark as Favourite</p>
			</div>
		</div>
	);

	const handleSubmit = () => {
		fileUploadHandler();
		window.location.reload();
	};

	const fileUploadHandler = async () => {
		setSubmitting(true);
		const data = new FormData();
		data.append("image", file);
		await FileService.uploadAvatar(data);
		setSubmitting(false);
	};

	const fetchUpdatedUser = async () => {
		setFetching(true);
		let res = await UserService.getUserBoard();
		setCurrentUser(res.user);
		setFetching(false);
	};

	useEffect(() => {
		fetchUpdatedUser();
	}, []);

	return (
		<>
			<div className={classes.profileContainer}>
				<div className={classes.imgContainer}>
					<IconButton
						className={classes.backBtn}
						onClick={() => history.push("/staff-database")}
					>
						<ArrowBackIcon />
					</IconButton>
					<img src={Logo} alt="Logo" className={classes.imgLogo} />
				</div>
				<div className={classes.chatbox}>UBEC CHATBOX</div>
				<div className={classes.profile}>
					<form className="image__form">
						<label htmlFor="display" className="display__option">
							Change Image
							<input
								className="profile__select"
								type="file"
								id="display"
								accept="image/*"
								onChange={(e) => setFile(e.target.files[0])}
							/>
						</label>
						<button className="share__button" type="submit" onClick={handleSubmit}>
							Submit
						</button>
					</form>

					{file ? (
						<div className="share__preview__container">
							<img
								className="share__img__preview"
								src={URL.createObjectURL(file)}
								alt=""
							/>
							{<Cancel className="share__cancel" onClick={() => setFile(null)} />}
						</div>
					) : (
						<div className="share__preview__container">
							{currentUser && currentUser.avatar ? (
								<img
									src={`${baseURL}/avatar/image/${currentUser.avatar}`}
									alt="avatar"
									className="share__img__preview"
								/>
							) : (
								<img src={Profile} alt="Logo" className="share__img__preview" />
							)}
						</div>
					)}
				</div>
				<div className={classes.usernameContainer}>
					<h5 className={classes.username}>
						{currentUser?.firstname} {currentUser?.lastname}
					</h5>

					<div className={classes.chatBottomIcon}>
						<IconButton onClick={handleOpen}>
							<MoreVertIcon type="button" className={classes.moreIcon} />
						</IconButton>
					</div>
				</div>
				<Modal
					open={open}
					onClose={handleClose}
					aria-describedby="simple-modal-description"
				>
					{body}
				</Modal>
			</div>
			{fetching && <Preloader text={"Fetching data"} />}
			{submitting && <Preloader text={"Loading"} />}
		</>
	);
};

export default ProfileBox;
